module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('p', {
    staticClass: "display-3 font-weight-thin"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("./../assets/img/logo.png"),
      "alt": "MyfirebaseLogo"
    }
  }), _vm._v(" "), _c('br'), _c('span', {
    staticClass: "colorw"
  }, [_vm._v("Witaj w aplikacji")]), _c('br'), _vm._v(" "), (_vm.$auth.user()) ? _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Wyloguj się")]) : _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.$router.push('/login')
      }
    }
  }, [_vm._v("Zaloguj się")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-359f1c2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome.vue
// module id = 155
// module chunks = 1